import { InAppBrowser, iOSAnimation, iOSViewStyle, ToolbarPosition } from "@capacitor/inappbrowser";
import { INavigator, IWindow, RedirectParams } from "oidc-client-ts";

export class NativeRedirectNavigator implements INavigator {
    public async prepare(_: RedirectParams): Promise<IWindow> {
      let abort: (reason: Error) => void;
      return {
          navigate: async (params): Promise<never> => {
            // We use a promise that never resolves to block the caller
            let confirm: () => void
            const promise = new Promise<void>((resolve, reject) => {
              confirm = resolve;
              abort = reject;
            });
            InAppBrowser.openInWebView({
              url: params.url,
              options: {
                showNavigationButtons: false,
                showToolbar: false,
                showURL: false,
                clearCache: false,
                clearSessionCache: false,
                leftToRight: true,
                mediaPlaybackRequiresUserAction: false,
                closeButtonText: "Annulla",
                toolbarPosition: ToolbarPosition.TOP,
                android: {
                  allowZoom: false,
                  hardwareBack: false,
                  pauseMedia: true,
                },
                iOS: {
                  allowOverScroll: false,
                  enableViewportScale: false,
                  allowInLineMediaPlayback: false,
                  surpressIncrementalRendering: false,
                  viewStyle: iOSViewStyle.FULL_SCREEN,
                  animationEffect: iOSAnimation.CROSS_DISSOLVE,
                  allowsBackForwardNavigationGestures: false,
                }
              }
            });
            InAppBrowser.addListener("browserPageNavigationCompleted", async (data) => {
              if (data.url?.startsWith("https://meraki-innovation.it")) {
                const catchedUrl = new URL(data.url);
                const redirectUrl = new URL(window.location.href);
                if (redirectUrl.search.length > 0) {
                  redirectUrl.search += "&";
                }
                redirectUrl.search += catchedUrl.search.substring(1);
                let targetWindow = window.self as Window;
                targetWindow.location.replace(redirectUrl);
                await InAppBrowser.close();
                confirm();
              }
              console.log("browser page navigation was completed. ", data);
            });
            return await (promise as Promise<never>);
          },
          close: () => {
            InAppBrowser.close();
            abort?.(new Error("Redirect aborted"));
          },
      };
    }

    public async callback(): Promise<void> {
      return;
    }
}